import { matchPath } from 'react-router';
import { permissions } from 'services/roles';

export interface PortalModule {
  name: string;
  path: string;
  // Extra paths that still belong to this module (e.g. the customer profile
  // lives under /CRM but is part of Customers).
  matchPaths?: string[];
  role: string[];
}

// The portal's top-level modules, in display order. This was the TopBar's tab
// list; it stays here so the TopBar title and the navigation that replaces
// those tabs read from one source.
export const PORTAL_MODULES: PortalModule[] = [
  { name: 'Internet', path: '/management', role: permissions.management },
  { name: 'Firewall', path: '/firewall', role: permissions.firewall },
  { name: 'Door access', path: '/door-access', role: permissions.doorAccess },
  { name: 'Analytics', path: '/analytics', role: permissions.analytics },
  { name: 'Attendance', path: '/attendance', role: permissions.attendance },
  { name: 'Marketing', path: '/marketing', role: permissions.marketing },
  { name: 'Loyalty', path: '/loyalty', role: permissions.marketing },
  {
    name: 'Customers',
    path: '/customers',
    matchPaths: ['/CRM'],
    role: permissions.marketing,
  },
  { name: 'Billing', path: '/billing', role: permissions.billing },
  { name: 'Audit logger', path: '/audit-logs', role: permissions.logger },
  { name: 'Staff', path: '/team-members', role: permissions.staff },
  { name: 'Notifications', path: '/notifications', role: permissions.all },
  { name: 'Settings', path: '/settings', role: permissions.settings },
];

const isMatch = (pathname: string, path: string) =>
  !!matchPath(pathname, { path, exact: false });

// The module the given route belongs to, or undefined outside of them.
export const getActiveModule = (pathname: string): PortalModule | undefined =>
  PORTAL_MODULES.find(
    (module) =>
      isMatch(pathname, module.path) ||
      (module.matchPaths || []).some((path) => isMatch(pathname, path)),
  );
